import CompLayout from "@/pcomponents/comp/layout/layout";
import BookOrderUseListArea from "@/pages/comp/book_order/book_order_use/common/list";

function BookOrderUseListPage(){
  return (
    <CompLayout >
      <BookOrderUseListArea></BookOrderUseListArea>
    </CompLayout>
  );
}

export default BookOrderUseListPage;